// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1vTel","footer":"ReportModalFilter_footer__IGAch"};